import { PostPatientBody } from "@/types";

import axios from "./axios";

const signUpPatient = async (patient: PostPatientBody) => {
  const toBase64 = (file: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const resultDriverLicenseFront = await toBase64(patient.patient.idFileDriverLicenseFront).catch((e) => Error(e));
  const resultDriverLicenseBack = await toBase64(patient.patient.idFileDriverLicenseBack).catch((e) => Error(e));
  const { data } = await axios.post("/patient", {
    ...patient,
    patient: {
      ...patient.patient,
      idFileDriverLicenseFront: resultDriverLicenseFront,
      idFileDriverLicenseBack: resultDriverLicenseBack,
    },
  });
  return data;
};

const getPatients = async () => {
  const { data } = await axios.get("/patient");
  return data;
};

const patientGetProfile = async (patientId: string) => {
  const { data } = await axios.get(`/patient/${patientId}`);
  return data;
};

const getSettings = async (patientId: string) => {
  const { data } = await axios.get(`/patient/${patientId}/settings`);
  return data;
};

const getAllByPractitionerId = async (practitionerId: string) => {
  const { data } = await axios.get(`patient`, { params: { practitionerId } });
  return data;
};

const avatarUpload = async (patientId: string, formData: FormData) => {
  const { data } = await axios.post(`/patient/${patientId}/avatar`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

const updateProfile = async (patientId: string, body: any) => {
  const { data } = await axios.put(`/patient/${patientId}`, body);
  return data;
};

const updateSettings = async (patientId: string, body: any) => {
  const { data } = await axios.put(`/patient/${patientId}/settings`, body);
  return data;
};

const updatePractitioner = async (patientId: string, practitionerId: string) => {
  const { data } = await axios.put(`/patient/${patientId}/practitioner`, {
    practitionerId,
  });
  return data;
};

export const PatientsApi = {
  signUpPatient,
  getPatients,
  patientGetProfile,
  getAllByPractitionerId,
  getSettings,
  avatarUpload,
  updateProfile,
  updateSettings,
  updatePractitioner,
};
